import api from './api';

/**
 * Referral Service (Creator-Referral-Programm)
 *
 * - Globales ?ref=-Capture beim App-Start: Code wird 30 Tage in
 *   localStorage gehalten (letzter Code überschreibt).
 * - Nach Registrierung/Login wird der gespeicherte Code einmalig per
 *   POST /referrals/claim eingelöst. Das Backend entscheidet, ob es ein
 *   gültiger Referral-Code ist (Produkt-Affiliate-Codes teilen denselben
 *   Parameter und werden dort still ignoriert).
 */

const STORAGE_KEY = 'monemee_referral';
const TTL_DAYS = 30;

/**
 * ?ref=-Parameter aus der aktuellen URL in localStorage übernehmen.
 * Wird einmalig beim App-Start aufgerufen (öffentliche Seiten).
 */
export function captureRefCode() {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('ref');
    if (!code || !/^[A-Za-z0-9]{4,16}$/.test(code)) return;

    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
      code: code.toUpperCase(),
      expiresAt: Date.now() + TTL_DAYS * 24 * 60 * 60 * 1000
    }));
  } catch {
    // localStorage nicht verfügbar (Private Mode etc.) — still ignorieren
  }
}

/**
 * Gespeicherten, noch gültigen Ref-Code lesen (oder null)
 */
export function getPendingRefCode() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const { code, expiresAt } = JSON.parse(raw);
    if (!code || !expiresAt || Date.now() > expiresAt) {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return code;
  } catch {
    return null;
  }
}

function clearPendingRefCode() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignorieren
  }
}

/**
 * Gespeicherten Code nach erfolgreicher Anmeldung einlösen.
 * Fire-and-forget: Fehler dürfen den Auth-Flow nie stören.
 */
export async function claimPendingReferral() {
  const code = getPendingRefCode();
  if (!code) return;
  try {
    await api.post('/referrals/claim', { code });
    clearPendingRefCode();
  } catch {
    // Claim still fehlgeschlagen (z.B. offline) — Code bleibt für den
    // nächsten Versuch gespeichert
  }
}

const referralService = {
  captureRefCode,
  getPendingRefCode,
  claimPendingReferral,
  getMe: () => api.get('/referrals/me'),
  getReferred: () => api.get('/referrals/me/referred')
};

export default referralService;
